/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { PartnerTiersType } from 'app/developer-v3/types/partnerDashboard';

import BetaImage from '../images/tiers/big/beta.svg';
import BronzeImage from '../images/tiers/big/bronze.svg';
import SilverImage from '../images/tiers/big/silver.svg';
import GoldImage from '../images/tiers/big/gold.svg';
import PlatinumImage from '../images/tiers/big/platinum.svg';

const styleRoot = css`
  display: flex;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const styleTier = css`
  width: 100%;
  height: auto;
  display: flex;
`;

type Props = {
  tier: PartnerTiersType;
};

export default function EmbedTierImage({ tier }: Props) {
  // Some of the tests use lowercase values and some user uppercase values, so
  // let's normalize it :(
  //
  // NOTE: This can have the type `Lowercase<PartnerTiersType>` when TypeScript
  // gets upgraded to a newer version...
  const tierName = tier.toLowerCase();
  const tierImages: Record<typeof tierName, JSX.Element> = {
    beta: <BetaImage alt="Beta" css={styleTier} />,
    bronze: <BronzeImage alt="Bronze" css={styleTier} />,
    silver: <SilverImage alt="Silver" css={styleTier} />,
    gold: <GoldImage alt="Gold" css={styleTier} />,
    platinum: <PlatinumImage alt="Platinum" css={styleTier} />,
  };
  return <figure css={styleRoot}>{tierImages[tierName]}</figure>;
}
